import React from 'react'

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  EuiHideFor
} from '@elastic/eui'

import YoutubeVideoCard from 'components/Software/Home_Automation/YoutubeVideoCard'
import IntroCards from './IntroDevSmartToC'
import IntroCardsMobile from './IntroDevSmartToC_mobile'

export default function IntroHome() {

  return (
    <React.Fragment>
      <EuiSpacer />
        <EuiTitle size="m">
            <h2>Smarthome Tutorials</h2>
        </EuiTitle>
        <EuiSpacer />
          <YoutubeVideoCard />
        <EuiSpacer />
        <EuiTitle size="s">
            <h4>Control your camera directly via its HTTP or MQTT interface.</h4>
        </EuiTitle>
        <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup gutterSize="l" direction="column" style={{margin: '0 7px'}} >
        <EuiFlexItem>
            <EuiHideFor sizes={['xs', 's', 'm', 'l']}>
              <IntroCards />
            </EuiHideFor>
            <EuiHideFor sizes={['xl']}>
              <IntroCardsMobile />
            </EuiHideFor>
        </EuiFlexItem>
    </EuiFlexGroup>
  </React.Fragment>
  );
}